var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"message-container"},[_c('img',{staticClass:"mr-2 icon",attrs:{"src":_vm.src}}),_c('p',{staticClass:"has-text-weight-semibold"},[_vm._v(_vm._s(_vm.text))]),_vm._t("custom")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }